module.exports = __webpack_public_path__ + "img/map-3-f.d0eb359b.png";